module.exports = __webpack_public_path__ + "img/tasks.406145c5.svg";